<template>
    <div>
        <button style="border-radius: 0;" type="button" class="btn btn-secondary" data-toggle="modal"
                :data-target="'#e' + modalId">
            <i class="fas fa-edit p-0"></i>
        </button>

        <div class="modal fade" :id="'e' + modalId" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2 class="m-0">{{ __('opening-hours.edit') }}</h2>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-3">
                            <div class="col-4 text-right">
                                {{ __('actions.open') }}
                            </div>
                            <div class="col-6">
                                <input v-model="newOpen" type="time"
                                       class="timerange__open form-control"
                                       size="10"
                                       placeholder="10:00">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 text-right">
                                {{ __('actions.close') }}
                            </div>
                            <div class="col-6">
                                <input v-model="newClose" type="time" class="timerange__open form-control" size="10"
                                       placeholder="19:00">
                            </div>
                        </div>
                        <div class="row mt-4" v-show="errors.length">
                            <div class="col-12">
                                <ul style="list-style: none;" class="text-danger text-center">
                                    <li v-for="error in errors">{{ error }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal"
                                @click="save"
                                v-show="errors.length === 0">
                            <i class="fas fa-plus"></i> {{ __('actions.submit') }}
                        </button>
                        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
                            <i class="fas fa-times"></i> {{ __('actions.abort') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PeriodModal',

    props: {
        open: String,
        close: String,
    },

    data() {
        return {
            modalId: Math.random().toString(36).substring(8),
            newOpen: '',
            newClose: '',
        }
    },

    mounted() {
        this.newOpen = this.open
        this.newClose = this.close
    },

    computed: {
        errors() {
            return []
        },
    },

    methods: {
        save() {
            this.$emit('update', this.open, this.close, this.newOpen, this.newClose)
        },
    },
}
</script>
